<template>
  <main id="set-new-password-page" class="page-container">
    <!-- Messaggi di errore/successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <!-- Contenitore del form -->
    <div id="set-password-form">
      <!-- Form -->
      <form class="set-password-form" @submit.prevent="resetPassword">
        <h1>Reimposta Password</h1>
        <!-- Prima password + toggle -->
        <div class="password-field">
          <input
            id="set-password"
            :type="showNewPassword ? 'text' : 'password'"
            placeholder="Nuova password"
            v-model="newPassword"
            required
          />
          <!-- Bottone occhio/lucchetto -->
          <button
            type="button"
            class="toggle-password-button"
            @click="toggleNewPassword"
          >
            <!-- Se showNewPassword è false, mostra 🔐; se true, mostra 🔓 -->
            <span v-if="!showNewPassword">
              <font-awesome-icon :icon="['fas', 'eye-slash']" />
            </span>
            <span v-else>
              <font-awesome-icon :icon="['fas', 'eye']" />
            </span>
          </button>
        </div>

        <!-- Seconda password + toggle -->
        <div class="password-field">
          <input
            id="set-password2"
            :type="showNewPassword2 ? 'text' : 'password'"
            placeholder="Conferma password"
            v-model="newPassword2"
            required
          />
          <button
            type="button"
            class="toggle-password-button"
            @click="toggleNewPassword2"
          >
            <span v-if="!showNewPassword2">
              <font-awesome-icon :icon="['fas', 'eye-slash']" />
            </span>
            <span v-else>
              <font-awesome-icon :icon="['fas', 'eye']" />
            </span>
          </button>
        </div>

        <!-- Bottone invio -->
        <button id="reset-button" type="submit">Reimposta Password</button>
      </form>
    </div>
  </main>
</template>

<script>
import { useToast } from "vue-toast-notification";
export default {
  setup() {
    const toast = useToast();
    return {
      toast,
    };
  },
  name: "SetNewPasswordPage",
  data() {
    return {
      newPassword: "",
      newPassword2: "",
      // errorMessage: "",
      // successMessage: "",
      /* Variabili per mostrare/nascondere le password */
      showNewPassword: false,
      showNewPassword2: false,
    };
  },
  methods: {
    toggleNewPassword() {
      this.showNewPassword = !this.showNewPassword;
    },
    toggleNewPassword2() {
      this.showNewPassword2 = !this.showNewPassword2;
    },
    async resetPassword() {
      try {
        const token = this.$route.query.token;
        if (this.newPassword !== this.newPassword2) {
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error("Le password non corrispondono!");
          // });
          return;
        }
        const payload = { password: this.newPassword };
        const response = await this.$axios.post(
          `/auth/reset-password?token=${token}`,
          payload
        );
        if (response.status === 200) {
          // this.$nextTick(() => {
          // this.successMessage =
          this.toast.success(
            response.data?.details || "Password reimpostata con successo!"
          );
          // });
        }
        // Reindirizza dopo 2 secondi
        setTimeout(() => {
          this.$router.push("/login");
        }, 2000);
      } catch (error) {
        // console.error("Errore reimpostazione password: ", error);
        // Se lo status è 400 => token scaduto o invalido
        if (error.response?.status === 400) {
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response?.data?.details ||
              "Token scaduto, richiedi nuovamente il link di recupero."
          );
          // });
          // Reindirizza dopo 2 secondi a /auth/verify-email
          setTimeout(() => {
            this.$router.push("/login/verify-email");
          }, 2000);
        } else {
          // Altri errori generici
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response?.data?.error ||
              "Errore durante la reimpostazione della password."
          );
          // });
        }
      }
    },
  },
};
</script>

<style src="@/css/SetNewPassword.css"></style>
